import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=7188eebb&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=js"
export * from "./OnBoarding.vue?vue&type=script&lang=js"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=7188eebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188eebb",
  null
  
)

export default component.exports